<template>
  <Modal :title="nama" :show.sync="xshow" width="400px" :submitText="''">
    <div>
      <Grid
        :datagrid.sync="datagrid"
        dbref="SPD.SelPerjalananPegawai"
        :dbparams="dbparams"
        style="height:calc(100vh - 100px)"
        :disabled="true"
        :columns="[
          {
            name: 'SPT',
            value: 'NoSPT',
            width: '120px',
          },
          {
            name: 'Tujuan',
            value: 'TempatTujuan',
            width: '120px',
          },
          {
            name: 'Berangkat',
            value: 'TglBerangkat',
            width: '120px',
          },
          {
            name: 'Kembali',
            value: 'TglKembali',
            width: '120px',
          },
          {
            name: 'Jml Hari',
            value: 'JmlHari',
            width: '120px',
          },
        ]"
      >
        <template v-slot:row-NoSPT="{ row }">
          <v-btn color="primary" small text @click="Download(row.PerjalananId)">
            {{ row.NoSPT }}
          </v-btn>
        </template>
        <template v-slot:row-JmlHari="{ row }">
          {{ row.JmlHari }} hari
        </template>
      </Grid>
      <!-- <template v-slot:left-action> </template> -->
    </div>
  </Modal>
</template>
<script>
export default {
  data: () => ({
    datagrid: [],
    xshow: false,
  }),
  props: {
    show: Boolean,
    nip: [String, Number],
    nama: String,
  },
  computed: {
    dbparams() {
      return { NIP: this.nip }
    },
  },
  watch: {
    show(val) {
      this.xshow = val
    },
    xshow(val) {
      this.$emit('update:show', val)
    },
  },
  methods: {
    async Download(id) {
      // this.$api.call('/reports/sppd/doc/' + this.forms.id)

      window.open(
        this.$api.url + '/reports/sppd/doc/SPPD_LENGKAP/' + id,
        '_blank'
      )
    },
    async Save() {
      let ret = await this.$api.call('', {})
      if (ret.success) this.$emit('update:show', false)
    },
  },
}
</script>
